import { FunctionComponent, useState } from "react";
import styles from "./ForgotPassword.module.css";
import { useNavigate } from "react-router-dom";
import { Button, CircularProgress, Dialog } from "@mui/material";
import PopupComponent from "../../components/shared-components/success-popup/PopupComponent";
import {useForm} from 'react-hook-form'
import EmailInputField from "../../components/shared-components/input-field/EmailInputField";
import AuthLayoutSubmitButton from "../../components/shared-components/buttons/AuthLayoutSubmitButton";
import { CustomPaperComponent } from "../../helper";
import { useLazyQuery } from "@apollo/client";
import { FORGOT_PASSWORD } from "./api/ForgotPassword";
import ToasterWithMessage from "../../components/shared-components/toaster";

interface SubmitData{
  email: string
}
const ForgotPassword: FunctionComponent = () => {
  const {error} = ToasterWithMessage();
  const {register,handleSubmit,reset,formState: {errors}} = useForm({defaultValues: {email:""}});
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [disableBtn, setDisableBtn] = useState<boolean>(false);


  const [forgotPassword] = useLazyQuery(FORGOT_PASSWORD, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
     if(data?.forgotPassword?.message.includes("successfully!")){
      setLoading(false);
      setOpenDialog(true);
     }
    },
    onError: (errors) => {
      setDisableBtn(!disableBtn);
      setOpenDialog(false);
      setLoading(false);
      if(errors?.graphQLErrors && errors.graphQLErrors.length > 0){
        const errorMessage = errors.graphQLErrors[0]?.message;
        if(errorMessage === "Invalid Email Id."){
          error('Invalid Email');
        }
      }else{
        error('Something went wrong!');
      }
    },
  });

  // navigating to the signin page
  const handleCancel = () => {
    navigate("/login");
  };


  //closes the success pop
  const handleCloseDialog = () => {
    setOpenDialog(false);
    navigate('/login')
  };

  //overrides the mui paper 
  const StyledComponent = CustomPaperComponent();

  const onSubmit = (data: SubmitData)=>{
    if(errors.email){
      setDisableBtn(disableBtn);
    }else{
      setDisableBtn(!disableBtn);
    }
    setLoading(true)
    forgotPassword({
      variables:{
        emailId : data.email
      }
    })
    reset({email: ""})
  }
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.textField}>
          <div className={styles.textFieldFullMain}>
            <div className={styles.titlePlaceholder}>
              <div className={styles.title}>Email</div>
              <div className={styles.asterisk}>*</div>
            </div>
            <EmailInputField disabled = {false} errors={errors} register={register} moduleName={'forgotPassword'}/>
          </div>
        </div>
        <br />
        <br />
        {
          loading
        ? 
          <div className={styles.forgotCircular}>
          <CircularProgress color={"primary"} size={30}/>
          </div>
        : ''
        }
        <div className={styles.ctaActions}>
          <AuthLayoutSubmitButton title={"Submit"} disableBtn={disableBtn} />
          <div className={styles.button} onClick={handleCancel}>
            <Button
              fullWidth
              sx={{
                height: "45px",
                "&.MuiButton-root": {
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  fontSize: "var(--sub-s-h2-16-semibold-center-size)",
                  fontFamily: "var(--body-b3-12-semibold-left)",
                  color: "var(--color-neutral-1000)",
                },
                "&:hover": {
                  backgroundColor: "#ffffff",
                },
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          PaperComponent={StyledComponent}
        >
          <PopupComponent
            handleClose={handleCloseDialog}
            title={"Email Sent Successfully!"}
            subTitle={"We have sent a password reset link to your email."}
          />
        </Dialog>
      </form>
    </>
  );
};

export default ForgotPassword;
